import { TableCellParams, TableColumn } from '../../../table/interfaces/table';
import { Destination } from '../../../shared/interfaces/destination';
import { EntityType } from '../../../shared/components/EntityType/EntityType';
import { nounPluralFormatter } from '../../../shared/utils/string/formatter';
import { GenericStatusLabel } from '../../../shared/components/GenericStatusLabel/GenericStatusLabel';

export const destinationTableColumns: TableColumn<Destination>[] = [
  {
    id: 'c1',
    field: 'id',
    headerName: 'ID',
    width: 40,
    valueFormatter: (params: TableCellParams<Destination>) => `#${params.row.data.seqId}`
  },
  {
    id: 'c2',
    field: 'name',
    headerName: 'Destination Name',
    width: 240,
    wrapOverflowingCellText: true
  },
  {
    id: 'c3',
    field: 'destinationType',
    headerName: 'Destination Type',
    width: 180,
    renderCell: (params: TableCellParams<Destination>) => (
      <EntityType
        logo={params.row.data.destinationType.logo}
        logoDarkMode={params.row.data.destinationType.logoDarkMode}
        title={params.row.data.destinationType.displayName}
      />
    )
  },
  {
    id: 'c5',
    field: 'integrationsCount',
    headerName: 'Pipelines Connected',
    width: 160,
    renderCell: (params: TableCellParams<Destination>) => (
      <>
        {nounPluralFormatter('Pipeline', {
          count: params.row.data.integrationsCount!,
          addCountWhenSingular: true
        })}
      </>
    )
  },
  {
    id: 'c6',
    field: 'status',
    headerName: 'Status',
    headerCellAlign: 'flex-end',
    cellAlign: 'flex-end',
    wrapOverflowingCellText: true,
    width: 100,
    isFlexible: true,
    renderCell: (params: TableCellParams<Destination>) => (
      <GenericStatusLabel status={params.row.data.status} withIcon={false} />
    )
  }
];
